import { defineMessages } from "react-intl";

const ACCESS_DENIED_ERROR = "access-denied-error";

const AccessDeniedErrorMessages = defineMessages({
  accessDenied: {
    id: `${ACCESS_DENIED_ERROR}.access-denied`,
    defaultMessage: "Access denied"
  },
  notPermitted: {
    id: `${ACCESS_DENIED_ERROR}.not-permitted`,
    defaultMessage: "Your account does not permit viewing this page."
  }
});

export default AccessDeniedErrorMessages;
